import axios from 'axios';
import { AgreementsApiResponse } from '@/rennovation/planning-view/types/api/agreement-api-response';
import { AgreementPayload, DutyChangeLogPayload } from '@/rennovation/planning-view/types/payloads/duty-payloads';

export class AgreementApiService {
	private baseUrl = '/api/agreements';

	async createAgreement(payload: AgreementPayload): Promise<DutyChangeLogPayload> {
		const response = await axios.post(`${this.baseUrl}`, payload);
		return response;
	}

	async loadAgreements(from, to): Promise<AgreementsApiResponse[]> {
		const response = await axios.get(`${this.baseUrl}?include=confirmed&from=${from}&to=${to}`);
		return response.data;
	}
}
